import { computed, ref } from "vue";

export const useFilterData = () => {
  const filtersData = ref({ language: {}, segment: {}, deviceCategory: {}, deviceType: {} });

  const filterDataKeys = computed(() => {
    const languageFilter = Object.keys(filtersData.value.language || {});
    const segmentFilter = Object.keys(filtersData.value.segment || {});
    const deviceFilter = Object.keys(filtersData.value.deviceCategory || {});
    const deviceTypeFilter = Object.keys(filtersData.value.deviceType || {});
    return {
      language: languageFilter,
      segment: segmentFilter,
      deviceCategory: deviceFilter,
      deviceType: deviceTypeFilter,
    };
  });

  const getDimensionFilters = () => {
    const filters = {};
    if (
      filterDataKeys.value.language.length ||
      filterDataKeys.value.segment.length ||
      filterDataKeys.value.deviceCategory.length ||
      filterDataKeys.value.deviceType.length
    )
      filters.dimension_filters = {};
    if (filterDataKeys.value.language.length)
      filters.dimension_filters.language = filterDataKeys.value.language;
    if (filterDataKeys.value.segment.length)
      filters.dimension_filters.segment_id = filterDataKeys.value.segment;
    if (filterDataKeys.value.deviceCategory.length)
      filters.dimension_filters.device_category = filterDataKeys.value.deviceCategory;
    if (filterDataKeys.value.deviceType.length)
      filters.dimension_filters.device_type = filterDataKeys.value.deviceType;
    return filters;
  };

  return { filtersData, filterDataKeys, getDimensionFilters };
};
